import { DEBUG, PATH } from '../constants';

const base = PATH;
const debug = DEBUG;

/**
 * Récupère toutes les progressions d’un utilisateur
 */
export async function getProgressionsByUser(userId) {
    try {
        const response = await fetch(`${base}progress/user/${userId}`);
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur getProgressionsByUser', error);
        throw error;
    }
}

/**
 * Récupère toutes les progressions d’un utilisateur
 */
export async function getLastsProgressionsByUser(userId) {
    try {
        const response = await fetch(`${base}progress/user/lasts/${userId}`);
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur getProgressionsByUser', error);
        throw error;
    }
}

/**
 * Récupère toutes les progressions d’un parcours
 */
export async function getProgressionsByParcours(parcoursId) {
    try {
        const response = await fetch(`${base}progress/parcours/${parcoursId}`);
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur getProgressionsByParcours', error);
        throw error;
    }
}

/**
 * Récupère la dernière progression d’un utilisateur sur un parcours
 */
export async function getLastProgression(userId, parcoursId) {
    try {
        const response = await fetch(`${base}progress/${userId}/${parcoursId}`);
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur getLastProgression', error);
        throw error;
    }
}

/**
 * Crée une nouvelle progression
 */
export async function createProgression(userId, parcoursId, nbPlayers = 1, achievedAt = null) {
    try {
        const response = await fetch(`${base}progress/insert`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id_utilisateur: userId,
                id_parcours: parcoursId,
                nb_players: nbPlayers,
                achieved_at: achievedAt
            })
        });

        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur createProgression', error);
        throw error;
    }
}

/**
 * Marque une progression comme terminée
 */
export async function achieveProgression(progressionId, userId, parcoursId) {
    try {
        const response = await fetch(`${base}progress/finish`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: progressionId,
                id_utilisateur: userId,
                id_parcours: parcoursId
            })
        });

        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur finishProgression', error);
        throw error;
    }
}

/**
 * Met à jour la progression avec la question courante
 */
export async function updateProgression(progressionId, userId, parcoursId, questionId) {
    try {
        const response = await fetch(`${base}progress/update`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: progressionId,
                id_utilisateur: userId,
                id_parcours: parcoursId,
                id_question: questionId
            })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur finishProgressInde', error);
        throw error;
    }
}


/**
 * Supprime une progression (admin uniquement)
 */
export async function deleteProgression(userId, parcoursId) {
    try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(`${base}progress/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                id_utilisateur: userId,
                id_parcours: parcoursId
            })
        });

        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur deleteProgression', error);
        throw error;
    }
}
